import { createFileRoute } from '@tanstack/react-router'
import { StaffPemilihan } from '../../../../components/StaffPemilihan'

export const Route = createFileRoute('/desa/$slug/dashboard/pemilihan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffPemilihan desaId={desaId} />
  },
})
